<template>
    <div>
        <div @mousemove="move" class="w3l-banner">
            <div :style="
                'transform: translate(' +
                (position == 'left' ? '20' : '-20') +
                'px,' +
                (position2 == 'top' ? '10' : '-10') +
                'px) scale(1.1)'
            " class="banner-image"></div>
            <div class="titleBox" :class="contType == 'e' ? 'titleBoxe' : ''">
                <div class="wow flipInX titleT1" :class="contType == 'e' ? 'titleT1e' : ''">{{ contList.title1[contType] }}</div>
                <div class="wow flipInX titleT2" :class="contType == 'e' ? 'titleT2e' : ''">{{ contList.title2[contType] }}</div>
                <img class="wow bounceInDown titlebgIcon1" src="../assets/img/ReceiptOrder/icon.svg" alt="" />
                <img class="wow bounceInDown titlebgIcon11" src="../assets/img/ReceiptOrder/icon_bg@2x.png" alt="" />
                <img class="wow bounceInUp titlebg1" src="../assets/img/ReceiptOrder/person.svg" alt="" />
                <img class="wow bounceInDown titlebg" src="../assets/img/ReceiptOrder/url.svg" alt="" />
            </div>
        </div>

        <div class="bgBox">
            <div class="carBg"></div>
        </div>
        <div class="contBox contHeight" style="background: #FBFBFB;height: 700px;">
            <div class="carBox">
                <div class="carTextBox">
                    <div class="wow bounceInUp text36">{{ contList.titles[contType][0] }}</div>
                    <div class="wow bounceInUp text16">{{ contList.titles[contType][1] }}</div>
                </div>
                <div class="carImgBox">
                    <img class="wow bounceInUp carImg" :src="imagesPC[contType][0]" alt="" />
                    <img class="wow bounceInUp carImg1" :src="imagesPC[contType][1]" alt="" />
                </div>
                <div class="carImgBox1">
                    <img class="wow bounceInUp carImg" :src="images[contType][0]" alt="" />
                    <img class="wow bounceInUp carImg1" :src="images[contType][1]" alt="" />
                </div>
            </div>
        </div>

        <div class="bgBox">
            <img class="bg1" src="../assets/img/ReceiptOrder/33.png" alt="">
            <img class="bg2" src="../assets/img/ReceiptOrder/47.svg" alt="">
            <img class="bg3" src="../assets/img/ReceiptOrder/33@2x.png" alt="">
            <img class="bg4" src="../assets/img/ReceiptOrder/47@2x.png" alt="">
        </div>

        <div class="contBox biBoxHeight" style="height: 700px;">
            <div class="biBox">
                <div class="biImgBox">
                    <img class="wow bounceInUp biImg" :src="imagesPC[contType][2]" alt="" />
                    <img class="wow bounceInUp biImg1" src="../assets/img/ReceiptOrder/1.svg" alt="" />
                </div>
                <div class="biImgBox1">
                    <img class="wow bounceInUp biImg" :src="images[contType][2]" alt="" />
                    <img class="wow bounceInUp biImg1" :src="images[contType][3]" alt="" />
                </div>
                <div class="biTextBox">
                    <div class="wow bounceInUp text36" :class="contType == 'e' ? 'text36e' : ''">{{ contList.titles[contType][2] }}</div>
                    <div class="wow bounceInUp text16" :class="contType == 'e' ? 'text16e' : ''">{{ contList.titles[contType][3] }}</div>
                </div>
            </div>
        </div>

        <div class="bgBox">
            <div class="carBg biBoxHeight"></div>
        </div>
        <div class="contBox biBoxHeight" style="background: #FBFBFB;height: 700px;">
            <div class="payBox">
                <div class="payTextBox">
                    <div class="wow bounceInUp text36">{{ contList.titles[contType][4] }}</div>
                    <div class="wow bounceInUp text16">{{ contList.titles[contType][5] }}</div>
                </div>
                <div class="payImgBox">
                    <img class="wow bounceInUp payImg" src="../assets/img/ReceiptOrder/Dashboard.svg" alt="" />
                    <img class="wow bounceInUp payImg1" :src="imagesPC[contType][3]" alt="" />
                    <img class="wow bounceInUp payImg2" :src="imagesPC[contType][4]" alt="" />
                </div>
                <div class="payImgBox1">
                    <img class="wow bounceInUp payImg" :src="images[contType][4]" alt="" />
                    <img class="wow bounceInUp payImg1" :src="images[contType][5]" alt="" />
                    <img class="wow bounceInUp payImg2" :src="images[contType][6]" alt="" />
                </div>
            </div>
        </div>


        <div class="bgBox">
            <img class="moneyBg" src="../assets/img/ReceiptOrder/27.svg" alt="">
            <img class="moneyBg1" src="../assets/img/ReceiptOrder/27.png" alt="">
        </div>
        <div class="contBox moneyH" style="height: 700px;">
            <div class="moneyBox">
                <div class="moneyImgBox">
                    <img class="wow bounceInUp moneyImg1" src="../assets/img/ReceiptOrder/Graph.png" alt="" />
                    <img class="wow bounceInUp moneyImg" :src="imagesPC[contType][5]" alt="" />
                </div>
                <div class="moneyImgBox1">
                    <img class="wow bounceInUp moneyImg1" :src="images[contType][7]" alt="" />
                    <img class="wow bounceInUp moneyImg" :src="images[contType][8]" alt="" />
                </div>
                <div class="moneyTextBox">
                    <div class="wow bounceInUp text36 textCF textF">{{ contList.titles[contType][6] }}</div>
                    <div class="wow bounceInUp text16 textCF textF">{{ contList.titles[contType][7] }}</div>
                </div>
            </div>
        </div>


        <div class="bgBox">
            <div class="carBg manageH"></div>
        </div>
        <div class="contBox manageH" style="background: #FBFBFB;height: 652px;">
            <div class="payBox">
                <div class="manageTextBox">
                    <div class="wow bounceInUp text36">{{ contList.titles[contType][8] }}</div>
                    <div class="wow bounceInUp text16">{{ contList.titles[contType][9] }}</div>
                </div>
                <div class="manageImgBox">
                    <img class="wow bounceInUp manageImg" :src="imagesPC[contType][6]" alt="" />
                    <img class="wow bounceInUp manageImg1" :src="imagesPC[contType][7]" alt="" />
                    <img class="wow bounceInUp manageImg2" :src="imagesPC[contType][8]" alt="" />
                </div>
                <div class="manageImgBox1">
                    <img class="wow bounceInUp manageImg" :src="images[contType][9]" alt="" />
                    <img class="wow bounceInUp manageImg1" :src="images[contType][10]" alt="" />
                    <img class="wow bounceInUp manageImg2" :src="images[contType][11]" alt="" />
                </div>
            </div>
        </div>

        <div class="bgBox">
            <img class="moneyBg moneyBge" src="../assets/img/ReceiptOrder/23.png" alt="">
        </div>
        <div class="contBox typeH" style="height: 875px;display: flex;align-items: center;">
            <img class="typeBg1" src="../assets/img/ReceiptOrder/233.png" alt="">
            <div class="typeBox" :class="contType == 'e' ? 'typeBoxe' : ''">
                <div class="wow bounceInUp text36">{{ contList.titles[contType][10] }}</div>
                <div class="wow bounceInUp text16">{{ contList.titles[contType][11] }}</div>
                <img class="wow bounceInUp typeImg" src="../assets/img/ReceiptOrder/419.png" alt="" />
                <img class="wow bounceInUp typeImg1" src="../assets/img/ReceiptOrder/419@2x.png" alt="" />
            </div>
        </div>

    </div>
</template>
<script>


import { WOW } from "wowjs";

export default {
    name: "index",
    data: (vm) => {
        return {
            bodyW: 0,
            bodyY: 0,
            position: "",
            position2: "",
            contList: {
                title1: {
                    z: "独立站收单解决方案",
                    f: "獨立站收單解決方案",
                    e:'One-Stop Acquiring Solutions'
                },
                title2: {
                    z: "仅需一次对接，即可联通全球跨境贸易，激活多种本地支付方式，\n支持VISA，MASTER，JCB等多种信用卡，畅享收单新体验。",
                    f: "僅需一次對接，即可聯通全球跨境貿易，激活多種本地支付方式，\n支持VISA，MASTER，JCB等多種信用卡，暢享收單新體驗。",
                    e:'With only once connection, Suntone connects global cross-border trades and activates a variety of local payment methods. Various credit cards including Visa, MasterCard, and JCB are supported, giving users a new acquiring experience.'
                },
                titles: {
                    z: [
                        "支持国际主流信用卡",
                        "支持主流信用卡支付，不限国家地域。",
                        "多元化币种支持",
                        "支持多元化币种，无需与多国支付机构对接",
                        "支持直连支付",
                        "无需跳转即可在独立站内完成便捷支付，提高支付率。",
                        "支持本地钱包支付",
                        "聚合了亚、美、欧主流的移动支付钱包。",
                        "支持一站式管理",
                        "支持商户一站式管理，商户后台实时管理所有交易数据。",
                        "支持多种建站方式",
                        "支持多种建站程序及SaaS系统，轻松接入支付系统。",
                    ],
                    f: [
                        "支持國際主流信用卡",
                        "支持主流信用卡支付，不限國家地域。",
                        "多元化幣種支持",
                        "支持多元化幣種，無需與多國支付機構對接",
                        "支持直連支付",
                        "無需跳轉即可在獨立站內完成便捷支付，提高支付率。",
                        "支持本地錢包支付",
                        "聚合了亞、美、歐主流的移動支付錢包。",
                        "支持一站式管理",
                        "支持商戶一站式管理，商戶後颱實時管理所有交易數據。",
                        "支持多種建站方式",
                        "支持多種建站程序及SaaS繫統，輕鬆接入支付繫統。",
                    ],
                    e: [
                        "Support International Mainstream Credit Cards",
                        "Accepts all major credit cards, no country or region limits.",
                        "Support Diversified Currencies",
                        "Multi-currency payments without the need to connect to multi-country payment institutions.",
                        "Support Direct Payment",
                        "Convenient payment can be completed in the website directly, improving the payment rate.",
                        "Support Local Wallet Payment",
                        "Integrates mainstream mobile payment wallets from Asia, America and Europe.",
                        "Support One-stop Management",
                        "Suntone supports one-stop management by merchants, allowing them for backstage real-time management of all transaction data.",
                        "Support Multiple Site Building Modes",
                        "Suntone supports a variety of SaaS platform procedures, allowing easy access to the payment system.",
                    ],
                },
            },
            contType: "z",
            images: {
                z: [
                    require('../assets/img/mobile/z/1589.png'),
                    require('../assets/img/mobile/z/1590.png'),

                    require('../assets/img/mobile/z/1583.png'),
                    require('../assets/img/mobile/z/1584.png'),

                    require('../assets/img/mobile/z/Dashboard.png'),
                    require('../assets/img/mobile/z/1587.png'),
                    require('../assets/img/mobile/z/1588.png'),

                    require('../assets/img/mobile/z/Graph.png'),
                    require('../assets/img/mobile/z/400.png'),

                    require('../assets/img/mobile/z/69.png'),
                    require('../assets/img/mobile/z/439.png'),
                    require('../assets/img/mobile/z/Widget.png'),
                ],
                f: [
                    require('../assets/img/mobile/f/1593.png'),
                    require('../assets/img/mobile/f/1594.png'),

                    require('../assets/img/mobile/f/1597.png'),
                    require('../assets/img/mobile/f/1598.png'),

                    require('../assets/img/mobile/f/Dashboard.png'),
                    require('../assets/img/mobile/f/1603.png'),
                    require('../assets/img/mobile/f/1604.png'),

                    require('../assets/img/mobile/f/Graph.png'),
                    require('../assets/img/mobile/f/1600.png'),

                    require('../assets/img/mobile/f/71.png'),
                    require('../assets/img/mobile/f/1606.png'),
                    require('../assets/img/mobile/f/Widget.png'),
                ],
                e: [
                    require('../assets/img/mobile/e/1591.png'),
                    require('../assets/img/mobile/e/1592.png'),

                    require('../assets/img/mobile/e/1595.png'),
                    require('../assets/img/mobile/e/1596.png'),

                    require('../assets/img/mobile/e/Dashboard.png'),
                    require('../assets/img/mobile/e/1601.png'),
                    require('../assets/img/mobile/e/1604.png'),

                    require('../assets/img/mobile/e/Graph.png'),
                    require('../assets/img/mobile/e/1599.png'),

                    require('../assets/img/mobile/e/70.png'),
                    require('../assets/img/mobile/e/1605.png'),
                    require('../assets/img/mobile/e/Widget.png'),
                ]
            },
            imagesPC: {
                z: [
                    require('../assets/img/ReceiptOrder/400.svg'),
                    require('../assets/img/ReceiptOrder/402.png'),

                    require('../assets/img/ReceiptOrder/400(3).svg'),

                    require('../assets/img/ReceiptOrder/400(1).svg'),
                    require('../assets/img/ReceiptOrder/402(1).svg'),

                    require('../assets/img/ReceiptOrder/400(2).png'),

                    require('../assets/img/ReceiptOrder/21.png'),
                    require('../assets/img/ReceiptOrder/439.png'),
                    require('../assets/img/ReceiptOrder/Widget.svg'),

                ],
                f: [
                    require('../assets/img/ReceiptOrder/400f.png'),
                    require('../assets/img/ReceiptOrder/402f.png'),

                    require('../assets/img/ReceiptOrder/400(3)f.png'),

                    require('../assets/img/ReceiptOrder/400(1)f.png'),
                    require('../assets/img/ReceiptOrder/402(1)f.png'),

                    require('../assets/img/ReceiptOrder/400(2)f.png'),

                    require('../assets/img/ReceiptOrder/21f.png'),
                    require('../assets/img/ReceiptOrder/439f.png'),
                    require('../assets/img/ReceiptOrder/Widgetf.png'),
                ],
                e: [
                    require('../assets/img/ReceiptOrder/400e.png'),
                    require('../assets/img/ReceiptOrder/402e.png'),

                    require('../assets/img/ReceiptOrder/400(3)e.png'),

                    require('../assets/img/ReceiptOrder/400(1)e.png'),
                    require('../assets/img/ReceiptOrder/402(1)e.png'),

                    require('../assets/img/ReceiptOrder/400(2)e.png'),

                    require('../assets/img/ReceiptOrder/21e.png'),
                    require('../assets/img/ReceiptOrder/439e.png'),
                    require('../assets/img/ReceiptOrder/Widgete.png'),

                    
                ]
            }
        };
    },
    methods: {
        move(e) {
            if (e.pageX > this.bodyW / 2) {
                this.position = "right";
            } else {
                this.position = "left";
            }
            if (e.pageY > 250) {
                this.position2 = "top";
            } else {
                this.position2 = "bottom";
            }
        },
        changeTypeTitleName() {
            if (this.contType == "f") {
                document.title = "独立站收单解决方案";
            } else if (this.contType == 'e') {
                document.title = 'Standalone Station Acquiring Solutions'
            } else {
                document.title = "独立站收单解决方案";
            }
        }
    },

    mounted() {
        this.bodyW = document.body.clientWidth;
        this.bodyY = document.body.clientHeight;
        var that = this;
        this.contType = window.localStorage.getItem('language');
        that.changeTypeTitleName()
        window.addEventListener('setItemEvent', function (e) {
            if (e.key == "language") {
                that.contType = e.newValue;
                that.changeTypeTitleName()
            }
        })
        var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 40,
            mobile: true,
            live: true,
        });
        wow.init();
    },
};
</script>


<style src="../assets/css/ReceiptOrder-pc.css"  scoped>

</style>
<style src="../assets/css/ReceiptOrder-phone.css"  scoped>

</style>
